import React, { useEffect, useState } from 'react'
import { list, deleteNewsByID } from '../api/news';
import Loader from '../components/Loader';
import { updateUserData, } from '../api/user';
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';

export default function News() {
    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);


    const [newsList, setNewsList] = useState([])
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [selectedNews, setSelectedNews] = useState(null);

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getNewsList = async () => {
        let newsList = await list();

        if (newsList.status >= 200 && newsList.status < 400) {
            console.log("newsList", newsList.data.data);
            setNewsList(newsList.data.data)
        }
    }
    useEffect(() => {
        getNewsList();
    }, [])

    const handleNewsEdit = async (obj) => {
        navigate(`/news/add/${obj._id}`)
    };
    const handleAddNews = async () => {
        navigate(`/news/add`)
    };

    const handleNewsDelete = async (obj) => {
        setShowPopup(true);
        setSelectedNews(obj)
        let text = 'Are you sure you want to delete the news? This action cannot be undone.'
        setPopUpMessage({
            "title": "Success",
            "text": text
        })
    }

    const onConfirmAction = async () => {
        if (loading) return; // ✅ prevent double call
        setShowPopup(false);
        setLoading(true);
        let newsDeleteRes = await deleteNewsByID(selectedNews?._id)
        setLoading(false);
        setShowPopup(true);
        if (newsDeleteRes.status >= 200 && newsDeleteRes.status < 400) {
            setApiError("News deleted successfully")
            setErrorStatus('success')
            getNewsList();
            setShowPopup(false);
        } else {
            setApiError(newsDeleteRes?.response?.data?.message || "There are some technical issue,please try again after sometimes")
            setErrorStatus('danger')
            setShowPopup(false);
        }
    }

    const formateDate = (dateStr) => {
        const formatted = new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        });
        return formatted;
    }
    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
                onConfirm={onConfirmAction}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="page-header">
                    <h3 className="page-title"> News </h3>
                    {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <button type="button" onClick={handleAddNews} className="btn btn-primary me-2">Add</button>
                        </ol>
                    </nav>
                </div>

                <div className="col-lg-12 grid-margin stretch-card">

                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">News List</h4>

                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Title </th>
                                            <th> Content </th>
                                            <th> Date </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {newsList.map((obj, index) => (
                                            <tr key={obj._id} status={obj.status}>
                                                <td> {index + 1} </td>
                                                <td> {obj.title} </td>
                                                <td> {obj.content} </td>
                                                <td> {formateDate(obj.updatedAt)} </td>

                                                <td>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleNewsEdit(obj)} className="btn btn-primary me-2" >Edit</button>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleNewsDelete(obj)} className="btn btn-danger me-2" >Delete</button>

                                                </td>
                                            </tr>
                                        ))}



                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
